import { render, staticRenderFns } from "./checkbox-with-text.vue?vue&type=template&id=95cc72c2&scoped=true"
import script from "./checkbox-with-text.vue?vue&type=script&lang=js"
export * from "./checkbox-with-text.vue?vue&type=script&lang=js"
import style0 from "./checkbox-with-text.vue?vue&type=style&index=0&id=95cc72c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cc72c2",
  null
  
)

export default component.exports